export const guideData = [
    {
        id: 1,
        title: "创建新模板", // 标题
        text: '将您调价调预算的策略创建成模板', // 文本
        list: [],
        preBtn: '', //上一步按钮
        nextBtn: "下一步", // 下一步按钮
        closeBtn: '', // 完成按钮
        shadowCoord: {top: '215px', left: '16px', width: '112px', height: '54px'}, // 阴影坐标
        textCoord: {top: '215px', left: '146px', width: '330px'} // 内容坐标
    },
    { // 表格内部需要单独计算
        id: 2,
        title: "应用到",
        text: '将模板应用到广告活动或广告组',
        list: [],
        preBtn: '上一步',
        nextBtn: "",
        closeBtn: '知道了',
        shadowCoord: {},
        textCoord: {},
        computing: {tableClass: '.guide-table-rule', elClass: '.guide-col-op', place: 'left'}, //配置了这个参数则会使用计算的方式去实现框选区域
        closeParams: {
            name: 'adAutoRule',
            description: '广告自动化页面提示展示'
        },
    },
  ]


  export const objectAdsType = {
    campaign: '广告活动',
    group: '广告组',
    placement: '广告位',
    keyword: '关键词',
    manualTarget: '商品投放',
    autoTarget: '投放组',
    asinSearch: '搜索词-ASIN',
    keywordSearch: '搜索词-关键词',
  }